"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleBarChart = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var recharts_1 = require("recharts");
var utils_1 = require("./utils");
require("./simpleBarChart.css");
var renderCustomizedAxisTick = function (props) { return function (o) {
    var COLOR_DARK_RED = '#ce0000';
    var COLOR_STRONG_GREEN = '#71b62c';
    var COLOR_GREY = '#666';
    var COLOR_YELLOW = '#ff9902';
    function getFillColor(p, index) {
        switch (p._tag) {
            case 'base':
                return p.data[index].d1 >= p.threshold ? COLOR_STRONG_GREEN : COLOR_DARK_RED;
            case 'base2': {
                if (p.data[index].d1 >= p.thresholds.d1 && p.data[index].d2 >= p.thresholds.d2) {
                    return COLOR_STRONG_GREEN;
                }
                if (p.data[index].d1 >= p.thresholds.d1 || p.data[index].d2 >= p.thresholds.d2) {
                    return COLOR_YELLOW;
                }
                return COLOR_DARK_RED;
            }
        }
    }
    return ((0, jsx_runtime_1.jsxs)("g", __assign({ transform: "translate(".concat(o.x, ",").concat(o.y, ")") }, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: "0", cy: "22", r: "5", fill: getFillColor(props, o.payload.index) }), (0, jsx_runtime_1.jsx)("text", __assign({ x: 25, y: -5, dy: 16, textAnchor: "end", fill: COLOR_GREY, fontSize: 14 }, { children: o.payload.value }))] })));
}; };
var SimpleBarChart = function (props) {
    function renderBarFillColor(c) {
        switch (c) {
            case 'lighter-blue':
                return '#14aff0';
            case 'strong-light-blue':
                return '#0e83cd';
        }
    }
    function renderReferenceLines(configs) {
        return (0, utils_1.buildArrayFromObjectKeys)(configs).map(function (tt) {
            return (0, function_1.pipe)(O.fromNullable(props.configs[tt]), O.map(function (config) { return ((0, jsx_runtime_1.jsx)(recharts_1.ReferenceLine, { y: config.threshold, stroke: renderBarFillColor(config.theme), strokeDasharray: "3 3" }, "reference_line_".concat(tt))); }), O.toNullable);
        });
    }
    function parsePropsToCustomTick(p) {
        if ((0, utils_1.isBaseData2)(p.data) &&
            p.configs.d1.threshold &&
            typeof p.configs.d2 !== 'undefined' &&
            p.configs.d2.threshold) {
            return {
                _tag: 'base2',
                data: p.data,
                thresholds: { d1: p.configs.d1.threshold, d2: p.configs.d2.threshold },
            };
        }
        return {
            _tag: 'base',
            data: p.data,
            threshold: p.configs.d1.threshold,
        };
    }
    function evaluateCustomizedAxisTick(p) {
        return (0, utils_1.hasDataThreshold1)(p) || (0, utils_1.hasDataThreshold2)(p);
    }
    return ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ width: "100%", height: props.height, className: "simple-bar-chart" }, { children: (0, jsx_runtime_1.jsxs)(recharts_1.BarChart, __assign({ data: props.data, barGap: 6 }, { children: [(0, jsx_runtime_1.jsx)(recharts_1.XAxis, __assign({ dataKey: "xLabel", axisLine: false, tickLine: false }, (evaluateCustomizedAxisTick(props)
                    ? { tick: renderCustomizedAxisTick(parsePropsToCustomTick(props)) }
                    : {}))), renderReferenceLines(props.configs), (0, jsx_runtime_1.jsx)(recharts_1.YAxis, __assign({ axisLine: false, tickLine: false }, (props.yAxisDomain ? { domain: props.yAxisDomain } : {}))), (0, jsx_runtime_1.jsx)(recharts_1.Tooltip, __assign({ cursor: false }, (props.customTooltip ? { content: props.customTooltip } : {}))), (0, jsx_runtime_1.jsx)(recharts_1.Bar, { dataKey: "d1", barSize: 10, fill: renderBarFillColor(props.configs.d1.theme) }), (0, jsx_runtime_1.jsx)(recharts_1.Bar, { dataKey: "d2", barSize: 10, fill: (0, function_1.pipe)(O.fromNullable(props.configs.d2), O.map(function (c) { return renderBarFillColor(c.theme); }), O.toUndefined) })] })) })));
};
exports.SimpleBarChart = SimpleBarChart;
//# sourceMappingURL=SimpleBarChart.js.map